export const getCookie = (name) => {
  if (typeof document === "undefined") return ""

  const value = document.cookie.replace(
    new RegExp(`(?:(?:^|.*;\\s*)${name}\\s*\\=\\s*([^;]*).*$)|^.*$`),
    "$1"
  )
  return decodeURIComponent(value)
}
